import type { Role } from '@/features/Clients';
import type { TariffFilters } from '@/features/Tariffs/types';
import { EntityRequestData } from '@/features/EntityManager/types';
import { RequestKonfigurationsParameters } from '@/services/api/types';
import { Merkmale } from '@/features/Global/types';

// General contract types
export enum CONTRACT_TYPE {
  ONLINE = 'online',
  INITIAL = 'erstantrag',
}

// Contract Request Data
export interface ContractRequestTariff {
  distributionInsuranceId: string;
  dokumente: string[];
  id: string;
  name: string;
}

export interface ContractRequestCalculation {
  id: string;
  empfohlenderTarifId: string;
  filters: TariffFilters;
  tarife: ContractRequestTariff[];
}

export interface ContractRequestConfiguration
  extends RequestKonfigurationsParameters {
  pool: string | null;
}

export interface ContractRequestData {
  antragsdaten: Record<string, unknown> & {
    gesellschaftsspezifischeFragen: string[];
    gesellschaftsspezifischeAntworten: Record<string, unknown>;
  };
  eingabedaten: Record<string, unknown>;
  berechnung: ContractRequestCalculation;
  konfigurationsParameter: ContractRequestConfiguration;
  entities: EntityRequestData<any>;
  kundenId: number;
  brokerId: string | null;
  merkmale: Merkmale;
}

// Legacy Request
export interface LegacyContractRequestData {
  antragsdaten: Record<string, unknown> & {
    gesellschaftsspezifischeAntworten: Record<string, unknown>;
  };
  eingabedaten: Record<string, unknown>;
  clientDaten: Partial<Record<Role, Record<string, unknown>>>;
  filters: TariffFilters;
  tarife: ContractRequestTariff[];
  konfigurationsParameter: ContractRequestConfiguration;
  berechnungsId: string;
  kundenId: number;
  empfohlenerTarifId: string;
}

// Contract Response
export interface ContractResponseStep {
  status: 'success' | 'error';
  messages: string[];
}

export interface ContractResponseSteps {
  Antragserstellung: ContractResponseStep;
  Beratung: ContractResponseStep;
  Courtage: ContractResponseStep;
  Fileupload: ContractResponseStep;
  Kuendigung: ContractResponseStep;
  Vorgang: ContractResponseStep;
  Vertrag: ContractResponseStep;
}

export interface ContractResponse {
  steps: ContractResponseSteps;
  contractId: number | null;
}

export const isStepsResponse = (value: unknown): value is ContractResponse => {
  if (typeof value === 'object' && value !== null) {
    return Object.hasOwn(value, 'steps');
  }
  return false;
};
